import { type FC, type TdHTMLAttributes, useContext } from 'react';

import { TableContext } from '../table-context';
import { Space, type SpaceProps } from './ui/space/space';

export type TCellSpaceProps = TdHTMLAttributes<HTMLTableCellElement> & {
  index?: number;
  city?: string;
  space: SpaceProps;
};

export const TCellSpace: FC<TCellSpaceProps> = ({ space, city, index, ...props }) => {
  const { columnsConfiguration } = useContext(TableContext);

  const column = index === undefined ? null : columnsConfiguration[index];
  const width = column?.width;

  return (
    <td style={{ width }} {...props}>
      <Space size="sm" title={space.title} caption={space.caption} />
    </td>
  );
};
